import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { TextFormat, Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './tax-tariff-tranche-history.reducer';

export const TaxTariffTrancheHistory = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const taxTariffTrancheHistoryList = useAppSelector(state => state.taxTariffTrancheHistory.entities);
  const loading = useAppSelector(state => state.taxTariffTrancheHistory.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="tax-tariff-tranche-history-heading" data-cy="TaxTariffTrancheHistoryHeading">
        <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.home.title">
          Tax Tariff Tranche Histories
        </Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.home.refreshListLabel">
              Refresh List
            </Translate>
          </Button>
          <Link
            to="/tax-tariff-tranche-history/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.home.createLabel">
              Create new Tax Tariff Tranche History
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {taxTariffTrancheHistoryList && taxTariffTrancheHistoryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('tariff')}>
                  <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.tariff">Tariff</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tariff')} />
                </th>
                <th className="hand" onClick={sort('effectiveDate')}>
                  <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.effectiveDate">
                    Effective Date
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('effectiveDate')} />
                </th>
                <th className="hand" onClick={sort('expirationDate')}>
                  <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.expirationDate">
                    Expiration Date
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('expirationDate')} />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.taxTariffTrancheType">
                    Tax Tariff Tranche Type
                  </Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {taxTariffTrancheHistoryList.map((taxTariffTrancheHistory, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button
                      tag={Link}
                      to={`/tax-tariff-tranche-history/${taxTariffTrancheHistory.id}`}
                      color="link"
                      size="sm"
                    >
                      {taxTariffTrancheHistory.id}
                    </Button>
                  </td>
                  <td>{taxTariffTrancheHistory.tariff}</td>
                  <td>
                    {taxTariffTrancheHistory.effectiveDate ? (
                      <TextFormat
                        type="date"
                        value={taxTariffTrancheHistory.effectiveDate}
                        format={APP_LOCAL_DATE_FORMAT}
                      />
                    ) : null}
                  </td>
                  <td>
                    {taxTariffTrancheHistory.expirationDate ? (
                      <TextFormat
                        type="date"
                        value={taxTariffTrancheHistory.expirationDate}
                        format={APP_LOCAL_DATE_FORMAT}
                      />
                    ) : null}
                  </td>
                  <td>
                    {taxTariffTrancheHistory.taxTariffTrancheType ? (
                      <Link to={`/tax-tariff-tranche/${taxTariffTrancheHistory.taxTariffTrancheType.id}`}>
                        {taxTariffTrancheHistory.taxTariffTrancheType.type}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/tax-tariff-tranche-history/${taxTariffTrancheHistory.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/tax-tariff-tranche-history/${taxTariffTrancheHistory.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/tax-tariff-tranche-history/${taxTariffTrancheHistory.id}/delete`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.taxTariffTrancheHistory.home.notFound">
                No Tax Tariff Tranche Histories found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default TaxTariffTrancheHistory;
